<template>
	<div class="topics-declaration">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page content-subProject">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb/>
									</div>
									<h3 class="header-title mb-3">区级课题</h3>
								</div>
								<!-- end page-title-box -->
							</div>
						</div>

						<div class="row row-subProject pt-3" v-if="list.length">
							<div class="col-md-4 col-xl-3" v-for="item in list" :key="item.id" @click="goSchoolTopicReviewList(item)">
								<a href="javascript:void(0);" class="card d-block">
									<div class="card-body text-center">
										<i class="mdi mdi-ballot-outline"></i>
										<h3>
											<span>{{ item.projectName }}</span>
										</h3>
										<p class="text-muted font-15 mb-0">申报时间</p>
										<p class="text-muted mb-0">{{ item.declareEndTime }}</p>
										<p class="text-muted mb-0">{{ item.trialEndTime }}</p>
									</div>
								</a>
							</div>
						</div>
						
						<!-- 没有项目时 -->
						<div class="no-data" v-else>
							当前没有课题申报通知
						</div>
						
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getEduProjectLsit } from '@/api/after/projectApplication';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'

export default {
	name: 'topicsDeclaration',
	components:{
		Breadcrumb
	},
	data() {
		return {
			list: []
		};
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			getEduProjectLsit().then(res => {
				console.log(res);
				if (res.code == 200) {
					this.list = res.data || [];
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 跳转到该项目的课题列表页面
		goSchoolTopicReviewList(data) {
			// this.$router.push({path:'/backstage/expertReviewList',query:{id:data.id,declareEndTime:data.declareEndTime,limit:data.memberNumberLimit}})
			this.$router.push({path:'/backstage/expertReviewList',query:{projectId:data.id,projectName:data.projectName}})
		}
	}
};
</script>

<style scoped lang="scss">
	h3 span{
		font-size: 16px;
		overflow: auto;
		white-space: wrap;
		text-overflow: unset;
	}
	.no-data{
		font-size: 24px;
		font-weight: bolder;
		text-align: center;
		padding: 30px 0;
	}
</style>
